import { takeEvery, takeLatest } from "redux-saga/effects";
import { getAlldata } from "../reducers/getapiDataSlice";
import { getapidataAsync } from "./get";



export function* watcherSaga() {
    yield takeEvery(getAlldata.type, getapidataAsync)
}
